<template>
  <div class="mb-10">
    <v-breadcrumbs
      :items="[{ title: 'アルバム一覧', href: '/memoru/top', color:'primary' }, { title: '' }]"
      class="px-0"
    ></v-breadcrumbs>

    <div class="d-flex align-center">
      <div class="pr-2">
        <v-chip v-if="available && album" color="success" variant="flat">
          公開中
        </v-chip>
        <v-chip v-else color="error">非公開中</v-chip>
      </div>
      <h3>{{ album ? album.title : "" }}</h3>
      <v-spacer />
      <v-checkbox
        v-model="bulkDelFlg"
        label="一括削除モード"
        hide-details
        density="compact"
        color="primary"
        class="mr-4"
      />
      <v-btn @click="bulkDeleteContent" color="error" v-if="bulkDelFlg">
        一括削除
      </v-btn>&emsp;
      <v-btn @click="updateDialog = true" color="primary" variant="outlined" v-if="!bulkDelFlg">
        <v-icon start>mdi-cog</v-icon>
        設定
      </v-btn>
<!--      &emsp;<v-btn @click="showTarget" color="primary" variant="outlined" v-if="bulkDelFlg">
        削除対象一覧
      </v-btn>
-->
    </div>

    <v-alert
       v-if="bulkDelFlg"
      class="my-4"
      type="info"
      color="primary"
      variant="outlined"
      density="compact"
      style="font-size: 0.9rem"
    >
      チェックボックスが表示されないアイテムは、購入済み（コンビニ決済の入金待ちを含む）のため削除できません。
    </v-alert>
    <v-card class="mt-4" variant="flat" color="grey-lighten-5" v-if="!bulkDelFlg">
      <v-container>
        <v-row>
          <v-col cols="3">
            <h5>カテゴリ</h5>
            <v-select
              v-model="searchFilters.category"
              :items="multimediaCategoryType"
              variant="outlined"
              hide-details
              density="compact"
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="3">
            <h5>売上枚数(下限)</h5>
            <v-text-field
              v-model="searchFilters.purchasedCountMin"
              variant="outlined"
              hide-details
              density="compact"
              suffix="枚"
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>撮影開始日</h5>
            <v-text-field
              v-model="searchFilters.dateFrom"
              variant="outlined"
              hide-details
              density="compact"
              type="date"
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>撮影終了日</h5>
            <v-text-field
              v-model="searchFilters.dateTo"
              variant="outlined"
              hide-details
              density="compact"
              type="date"
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <h5>ステータス</h5>
            <v-select
              v-model="searchFilters.status"
              :items="statusOptions"
              item-title="label"
              item-value="value"
              variant="outlined"
              hide-details
              density="compact"
              color="primary"
            >
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center">
                  <v-icon 
                    v-if="item.raw.color" 
                    size="small" 
                    :color="item.raw.color" 
                    class="mr-2"
                  >
                    mdi-circle
                  </v-icon>
                  {{ item.title }}
                </div>
              </template>

              <template v-slot:item="{ item, props }">
                <v-list-item v-bind="props">
                  <template v-slot:prepend v-if="item.raw.color">
                    <v-icon size="small" :color="item.raw.color" class="mr-2">
                      mdi-circle
                    </v-icon>
                  </template>
                </v-list-item>
              </template>
            </v-select>
          </v-col>
          <v-col cols="3">
            <h5>シリアルNO</h5>
            <v-text-field
              v-model="searchFilters.serialNumber"
              variant="outlined"
              hide-details
              density="compact"
              color="primary"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="4">
            <v-btn
              @click="listContents"
              :loading="loading"
              color="primary"
              block
              variant="flat"
              >検索
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <div class="pt-4">
      <v-container>
        <v-row v-if="contents">
          <v-col>
            <h5>全{{ contents.total || 0 }}件</h5>
          </v-col>
        </v-row>
        <v-row v-if="contents">
          <v-col cols="3" v-for="(item, i) in contents.items" :key="i">
            <memoru-content-card
              @click="onClickContent(item)"
              :loading="loading"
              :content="item"
              :bulkDelFlg="bulkDelFlg"
              v-model:bulkDelTarget="bulkDelTarget"
            />
          </v-col>
        </v-row>
      </v-container>

      <v-pagination
        class="pt-4"
        v-if="contents"
        v-model="page"
        :length="Math.ceil(contents.total / searchFilters.limit)"
        active-color="primary"
      ></v-pagination>
    </div>

    <v-dialog v-model="updateDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title> アルバム設定 </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="updateAlbumInput.title"
                  :rules="[required]"
                  label="タイトル*"
                  hide-details
                  variant="outlined"
                  density="compact"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="updateAlbumInput.year"
                  :rules="[required]"
                  label="年度*"
                  hide-details
                  suffix="年度"
                  variant="outlined"
                  density="compact"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12">
                <v-select
                  v-model="updateAlbumInput.nurseryClassIds"
                  :items="classes"
                  item-title="className"
                  item-value="classId"
                  label="クラス"
                  hide-details
                  variant="outlined"
                  density="compact"
                  multiple
                  chips
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="date"
                  v-model="internalDateAfter"
                  label="公開開始日"
                  hide-details
                  clearable
                  variant="outlined"
                  density="compact"
                  @update:model-value="updateCombinedDateTimeAfter"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="time"
                  v-model="internalTimeAfter"
                  label="公開開始時"
                  hide-details
                  clearable
                  variant="outlined"
                  density="compact"
                  @update:model-value="updateCombinedDateTimeAfter"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-if="showAvailableBefore"
                  type="date"
                  v-model="internalDateBefore"
                  label="公開終了日"
                  hide-details
                  clearable
                  variant="outlined"
                  density="compact"
                  @update:model-value="updateCombinedDateTimeBefore"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-if="showAvailableBefore"
                  type="time"
                  v-model="internalTimeBefore"
                  label="公開終了時"
                  hide-details
                  clearable
                  variant="outlined"
                  density="compact"
                  @update:model-value="updateCombinedDateTimeBefore"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="updateAlbumInput.comment"
                  label="コメント"
                  hide-details
                  variant="outlined"
                  density="compact"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-btn @click="updateDialog = false" color="grey" variant="text">
                キャンセル
              </v-btn>
              <v-spacer />
              <v-btn
                @click="updateAlbum"
                color="primary"
                :loading="loading"
                variant="flat"
                >保存
              </v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detailDialog" max-width="1200px">
      <v-card>
        <v-card-title>詳細</v-card-title>
        <v-card-text>
          <v-container v-if="selectedContent">
            <v-row v-if="selectedContent.category == 'photo'" justify="center">
              <v-col cols="8">
                <v-img
                  height="500"
                  :src="selectedContent.downloadImageUrl"
                ></v-img>
              </v-col>
            </v-row>
            <v-row v-if="selectedContent.category == 'movie'" justify="center">
              <v-col cols="8">
                <video
                  width="100%"
                  height="500"
                  muted
                  controls
                  :src="selectedContent.downloadImageUrl"
                ></video>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-col cols="2">
                <v-btn
                  v-if="!isPurchasedContent(selectedContent)"
                  @click="deleteContent"
                  :loading="loading"
                  color="error"
                  variant="flat"
                  size="small"
                >
                  削除
                </v-btn>
                <v-btn
                  v-else
                  :loading="loading"
                  color="grey"
                  variant="flat"
                  size="small"
                >
                  購入済み
                </v-btn>
              </v-col>
              <v-spacer />
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isDelDialog" max-width="500px" persistent>
      <v-card class="pa-4">
        <v-card-title class="d-flex flex-column align-center text-center px-6 pt-6 pb-2">
          <v-icon class="text-orange-lighten-2 mb-2" size="72px">
            mdi-alert-circle-outline
          </v-icon>
          <div class="text-h6">
            選択した{{ bulkDelTarget.length }}のアイテムを削除します。<br>
            削除後この操作は取り消せません。<br>
            削除しますか？
          </div>
        </v-card-title>

        <v-card-actions class="justify-space-between gs-4 px-6 pb-4">
          <v-btn
            variant="outlined"
            color="grey-darken-1"
            class="px-6"
            rounded="md"
            @click="isDelDialog = false"
            :loading="loading"
          >
            キャンセル
          </v-btn>

          <v-btn
            variant="flat"
            color="error"
            class="px-6 text-white"
            rounded="md"
            @click="bulkDeleteContentBody()"
            :loading="loading"
          >
            削除
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MemoruContentCard from "@/components/atoms/MemoruContentCard.vue";
import { memoruModule } from "@/store/dataModules/memoruModule";
import {
  MultimediaAlbumResponse,
  MultimediaListResponse,
  MultimediaResponse,
  NurseryClassResponse,
} from "chaild-api/lib";
import { multimediaCategoryType } from "@/constants/memoru";
import { isPurchasedContent } from "@/utils/MemoruUtil";
import dayjs from "dayjs";
import ApiMemoru from "@/api/ApiMemoru";
import ValidationMixin from "@/mixins/ValidationMixin";
import { classModule } from "@/store/dataModules/classModule";
import LocalDataService from "@/service/LocalDataService";
import { snackbarModule } from "@/store/viewModules/snackbarModule";

export default defineComponent({
  name: "MemoruContent",

  mixins: [ValidationMixin],

  components: {
    MemoruContentCard,
  },

  async mounted() {
    await this.listContents();
    await this.getAlbum();
    await this.listClasses();
  },

  data() {
    return {
      isDelDialog: false,
      bulkDelTarget: [],
      bulkDelFlg: false,
      selectedStatus: "",
      multimediaCategoryType: multimediaCategoryType,
      loading: false,
      updateDialog: false,
      detailDialog: false,
      searchFilters: {
        category: "",
        dateFrom: "",
        dateTo: "",
        purchasedCountMin: "",
        limit: 20,
        skip: 0,
        serialNumber: "",
      },
      updateAlbumInput: {
        title: "",
        year: "" as string | number,
        nurseryClassIds: [] as any[],
        comment: "",
        availableAfter: "",
        availableBefore: "" as string | null,
      },
      selectedContent: null as null | MultimediaResponse,
      showAvailableBefore: true,
      internalDateAfter: '' as string | null,
      internalTimeAfter: '00:00' as string | null,
      internalDateBefore: '' as string | null,
      internalTimeBefore: '00:00' as string | null,
    };
  },

  computed: {
    statusOptions() {
      return [
        { label: '', value: '', color: '' },
        { label: '処理中', value: 'inProgress', color: '#ff9800' },
        { label: '完了', value: 'completed', color: '#4caf50' },
        { label: '失敗', value: 'failed', color: '#FF5252' }
      ];
    },
    albumId(): string {
      const p = this.$route.params.albumId;
      return typeof p === "string" ? p : p?.[0] ?? "";
    },
    contents: function (): MultimediaListResponse | null {
      return memoruModule.contents;
    },
    album: function (): MultimediaAlbumResponse | null {
      return memoruModule.album;
    },
    available: function (): boolean {
      if (this.album) {
        if (
          dayjs().isAfter(this.album.availableAfter) &&
          (!this.album.availableBefore ||
            dayjs().isBefore(this.album.availableBefore))
        ) {
          return true;
        }
        return false;
      }
      return true;
    },
    page: {
      get(): number {
        // ⭕️ 修正2: ページ番号の計算ロジックを修正
        return Math.floor(this.searchFilters.skip / this.searchFilters.limit) + 1;
      },
      set(value: number) {
        this.searchFilters.skip = (value - 1) * this.searchFilters.limit;
        this.listContents();
        // ※ 元コードにあった this.searchFilters.skip = value * this.searchFilters.limit; はバグなので削除
      },
    },
    classes(): NurseryClassResponse[] {
      if (this.updateAlbumInput.year) {
        return classModule.classes.filter((c) => {
          return String(c.year) == this.updateAlbumInput.year;
        });
      } else {
        return classModule.classes;
      }
    },
  },

  watch: {
    internalDateBefore: 'updateCombinedDateTimeBefore',
    internalTimeBefore: 'updateCombinedDateTimeBefore',
    'updateAlbumInput.availableBefore': {
      handler(newValue) {
        if (newValue) {
          const parts = newValue.split('T');
          if (parts.length === 2) {
            this.internalDateBefore = parts[0];
            this.internalTimeBefore = parts[1];
          }
        } else {
          this.internalDateBefore = '';
          this.internalTimeBefore = '00:00';
        }
      },
      immediate: true
    },
    internalDateAfter: 'updateCombinedDateTimeAfter',
    internalTimeAfter: 'updateCombinedDateTimeAfter',
    'updateAlbumInput.availableAfter': {
      handler(newValue) {
        if (newValue) {
          const parts = newValue.split('T');
          if (parts.length === 2) {
            this.internalDateAfter = parts[0];
            this.internalTimeAfter = parts[1];
          }
        } else {
          this.internalDateAfter = '';
          this.internalTimeAfter = '00:00';
        }
      },
      immediate: true
    },
  },

  methods: {
    isPurchasedContent,
    showTarget() {
      alert(this.bulkDelTarget.join(','));
    },
    /**
     * 日付と時刻の値を結合し、updateAlbumInput.availableAfter を更新する
     */
    updateCombinedDateTimeAfter() {
      if (this.internalDateAfter) {
        const combinedDateTimeAfter = `${this.internalDateAfter}T${this.internalTimeAfter || '00:00'}`;
        this.updateAlbumInput.availableAfter = combinedDateTimeAfter;
      } else {
        this.updateAlbumInput.availableAfter = '';
      }
    },
    updateCombinedDateTimeBefore() {
      if (this.internalDateBefore) {
        const combinedDateTimeBefore = `${this.internalDateBefore}T${this.internalTimeBefore || '00:00'}`;
        this.updateAlbumInput.availableBefore = combinedDateTimeBefore;
      } else {
        this.updateAlbumInput.availableBefore = '';
      }
    },
    async listContents() {
      this.loading = true;
      await memoruModule.listContents({
        ...this.searchFilters,
        albumId: this.albumId,
      });
      this.loading = false;
    },
    async getAlbum() {
      this.loading = true;
      if (this.albumId) {
        await memoruModule
          .getAlbum({
            albumId: this.albumId,
          })
          .catch();
        if (this.album) {
          this.updateAlbumInput = {
            title: this.album.title,
            year: this.album.year,
            nurseryClassIds:
              this.album.nurseryClasses.map((c) => c.classId) || [],
            comment: this.album.comment || "",
            availableAfter: this.formatDate(this.album.availableAfter),
            availableBefore: this.formatDate(this.album.availableBefore ?? ''),
          };
          if (!this.updateAlbumInput.availableBefore) {
            this.internalDateBefore = null;
            this.internalTimeBefore = null;
          }

          this.showAvailableBefore = false;
          this.$nextTick(() => {
            this.showAvailableBefore = true;
          })
        }
      }
      this.loading = false;
    },
    async updateAlbum() {
      this.loading = true;
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        const response = await ApiMemoru.updateAlbum({
          nurseryId,
          albumId: this.albumId,
          ...this.updateAlbumInput,
        }).catch(() => (this.loading = false));
        if (response) {
          snackbarModule.snackOn({
            message: "アルバムを更新しました",
          });
          this.updateDialog = false;
          await this.listContents();
          await this.getAlbum();
        }
      }
      this.loading = false;
    },
    async deleteContent() {
      const answer = confirm("削除しますか？");
      if (answer && this.selectedContent) {
        this.loading = true;
        const response = await ApiMemoru.deleteContent({
          multimediaId: this.selectedContent.multimediaId,
        }).catch(() => (this.loading = false));
        if (response) {
          this.detailDialog = false;
          // 購入済み (コンビニ決済の入金待ちを含む) の場合はAPIで削除されず空配列が返る
          if (Array.isArray(response) && response.length === 0) {
            alert("購入済みのアイテムのため削除できませんでした。");
          } else {
            alert("削除しました");
          }
          await this.listContents();
        }
        this.loading = false;
      }
    },
    async bulkDeleteContent() {
      if (!this.bulkDelFlg) {
        this.bulkDelFlg = true;
        return;
      }
      this.isDelDialog = true;
    },
    async bulkDeleteContentBody() {
      if (this.bulkDelTarget.length > 0) {
        this.loading = true;
        const response = await ApiMemoru.deleteContent({
          multimediaIds: this.bulkDelTarget,
        }).catch(() => (this.loading = false, this.isDelDialog = false, this.bulkDelTarget = []));
        if (response && response.length == this.bulkDelTarget.length) {
          this.detailDialog = false;
          this.isDelDialog = false;
          alert("削除しました");
          await this.listContents();
        } else {
          this.detailDialog = false;
          this.isDelDialog = false;
          alert("削除処理中に購入したアイテムが入っていたため、すべては削除できませんでした。");
          await this.listContents();
        }
        this.loading = false;
      } else {
        alert("アイテムが選択されてません。");
      }
      this.isDelDialog = false;
      this.bulkDelTarget = [];
    },
    async listClasses() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await classModule.listClass({
          nurseryId,
        });
      }
    },
    async onClickContent(value: MultimediaResponse) {
      if (value.multimediaId) {
        this.loading = true;
        const response = await ApiMemoru.getContent({
          multimediaId: value.multimediaId,
        }).catch(() => (this.loading = false));
        this.selectedContent = response;
        this.detailDialog = true;
        this.loading = false;
      }
    },
    formatDate(value: string): string {
      if (!value) {
        return "";
      }
      return dayjs(value).format("YYYY-MM-DDTHH:mm");
    },
  },
});
</script>

<style scoped>
:deep(.v-pagination__item--is-active .v-btn) {
  background-color: rgb(var(--v-theme-primary)) !important;
  color: white !important;
  font-weight: bold;
  transform: scale(1.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}
</style>